import React from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../reducers";
import {ReactComponent as TrophySolidIco} from "../../../../images/icons/trophy-star-solid.svg";
import {StoreConfigLoyaltyApi} from "../../../services/Api/types";
import PopupModal from "../../Modal/PopupModal";

interface OwnProps {
    config_loyalty: StoreConfigLoyaltyApi,
    onHide: () => void,
    onShow?: () => void,
    onClick: () => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function LoyaltyPointsInfoModalComponent(props: Props) {
    const {t} = useTranslation();

    return <PopupModal
                show
                onHide={props.onHide}
                onShow={props.onShow}
                headerIcon={<TrophySolidIco/>}
                headerIconClassName="text-success"
                title={t("modules.user.field.points_program.title")}
                description={t("modules.user.field.points_program.description")}
                bodyContent={
                    <>
                        {props.config_loyalty.points?.info && (
                            <p className="text-center">
                                {props.config_loyalty.points?.info}
                            </p>
                        )}
                    </>
                }
                primaryButton={
                    <button className={"btn btn-primary w-100"} onClick={props.onClick}>
                        {t("modules.user.action.show_vouchers.title")}
                    </button>
                }
    />
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(LoyaltyPointsInfoModalComponent));
